module.exports = __webpack_public_path__ + "static/telemed-link_2-507d8beaa7dea60bef14394cdaee8ded.jpg";